import { jsxs, jsx } from "react/jsx-runtime";
import { useClassNameFactory } from "@contember/react-utils";
import { memo, Fragment } from "react";
import { Dropdown } from "../../Dropdown/Dropdown.js";
import { toStateClass } from "../../../utils/toStateClass.js";
import { Button } from "../../Forms/Button/Button.js";
import { Icon } from "../../Icon/Icon.js";
import { ButtonGroup } from "../../Forms/Button/ButtonGroup.js";
const EditorTableElement = memo(function EditorTableElement2({
  rowCount,
  columnCount,
  extendTable,
  shrinkTable,
  toggleRowHeaderScope,
  toggleColumnHeaderScope,
  justifyColumn,
  deleteTable,
  //selectTable,
  isSelected,
  isFocused,
  children
}) {
  const componentClassName = useClassNameFactory("editorTable");
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: componentClassName(null, [toStateClass("focused", isFocused), toStateClass("selected", isSelected)]),
      style: {
        ["--cui-editorTable-rowCount"]: rowCount,
        ["--cui-editorTable-columnCount"]: columnCount
      },
      children: [
        /* @__PURE__ */ jsx("div", { className: componentClassName("handle"), contentEditable: false }),
        /* @__PURE__ */ jsx("div", { className: componentClassName("remove"), contentEditable: false, children: /* @__PURE__ */ jsx(Button, { onClick: deleteTable, square: true, borderRadius: "full", size: "small", distinction: "seamless", children: /* @__PURE__ */ jsx(Icon, { blueprintIcon: "trash" }) }) }),
        /* @__PURE__ */ jsx("div", { className: componentClassName("columnControls"), contentEditable: false, children: Array.from({ length: columnCount + 1 }, (_, columnNumber) => {
          const columnStyle = { ["--cui-editorTable-column"]: columnNumber };
          return /* @__PURE__ */ jsxs(Fragment, { children: [
            columnNumber < columnCount ? /* @__PURE__ */ jsx(
              Dropdown,
              {
                buttonProps: {
                  borderRadius: "full",
                  children: /* @__PURE__ */ jsx(Icon, { blueprintIcon: "more" }),
                  className: componentClassName("columnControls-more"),
                  distinction: "seamless",
                  size: "small",
                  square: true,
                  style: columnStyle
                },
                styledContent: false,
                children: /* @__PURE__ */ jsxs(ButtonGroup, { display: "block", children: [
                  columnNumber === 0 && /* @__PURE__ */ jsx(Button, { square: true, borderRadius: "full", size: "small", onClick: () => toggleColumnHeaderScope(columnNumber, "row"), children: /* @__PURE__ */ jsx(Icon, { blueprintIcon: "header", size: "small" }) }),
                  /* @__PURE__ */ jsx(Button, { square: true, borderRadius: "full", size: "small", onClick: () => justifyColumn(columnNumber, "start"), children: /* @__PURE__ */ jsx(Icon, { blueprintIcon: "align-left", size: "small" }) }),
                  /* @__PURE__ */ jsx(Button, { square: true, borderRadius: "full", size: "small", onClick: () => justifyColumn(columnNumber, "center"), children: /* @__PURE__ */ jsx(Icon, { blueprintIcon: "align-center", size: "small" }) }),
                  /* @__PURE__ */ jsx(Button, { square: true, borderRadius: "full", size: "small", onClick: () => justifyColumn(columnNumber, "end"), children: /* @__PURE__ */ jsx(Icon, { blueprintIcon: "align-right", size: "small" }) })
                ] })
              }
            ) : /* @__PURE__ */ jsx("span", { className: componentClassName("stub") }),
            columnNumber < columnCount ? /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                onClick: () => shrinkTable("column", columnNumber),
                className: componentClassName("columnControls-item", [
                  columnNumber === 0 && componentClassName("columnControls-item-first"),
                  columnNumber === columnCount - 1 && componentClassName("columnControls-item-last")
                ]),
                style: columnStyle,
                children: /* @__PURE__ */ jsx(Icon, { blueprintIcon: "trash" })
              }
            ) : /* @__PURE__ */ jsx("span", { className: componentClassName("stub") }),
            /* @__PURE__ */ jsx(
              Button,
              {
                onClick: () => extendTable("column", columnNumber),
                className: componentClassName("columnControls-add"),
                square: true,
                borderRadius: "full",
                size: "small",
                distinction: "seamless",
                style: columnStyle,
                children: /* @__PURE__ */ jsx(Icon, { blueprintIcon: "plus" })
              }
            ),
            /* @__PURE__ */ jsx("div", { className: componentClassName("columnControls-line"), style: columnStyle })
          ] }, columnNumber);
        }) }),
        /* @__PURE__ */ jsx("div", { className: componentClassName("rowControls"), contentEditable: false, children: Array.from({ length: rowCount + 1 }, (_, rowNumber) => {
          const rowStyle = { ["--cui-editorTable-row"]: rowNumber };
          return /* @__PURE__ */ jsxs(Fragment, { children: [
            rowNumber < rowCount && rowNumber === 0 ? /* @__PURE__ */ jsx(
              Dropdown,
              {
                buttonProps: {
                  borderRadius: "full",
                  children: /* @__PURE__ */ jsx(Icon, { blueprintIcon: "more" }),
                  className: componentClassName("rowControls-more"),
                  distinction: "seamless",
                  size: "small",
                  square: true,
                  style: rowStyle
                },
                styledContent: false,
                alignment: "right",
                children: /* @__PURE__ */ jsx(Button, { square: true, borderRadius: "full", size: "small", onClick: () => toggleRowHeaderScope(rowNumber, "table"), children: /* @__PURE__ */ jsx(Icon, { blueprintIcon: "header", size: "small" }) })
              }
            ) : /* @__PURE__ */ jsx("span", { className: componentClassName("stub") }),
            rowNumber < rowCount ? /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                onClick: () => shrinkTable("row", rowNumber),
                className: componentClassName("rowControls-item", [
                  rowNumber === 0 && componentClassName("rowControls-item-first"),
                  rowNumber === rowCount - 1 && componentClassName("rowControls-item-last")
                ]),
                style: rowStyle,
                children: /* @__PURE__ */ jsx(Icon, { blueprintIcon: "trash" })
              }
            ) : /* @__PURE__ */ jsx("span", { className: componentClassName("stub") }),
            /* @__PURE__ */ jsx(
              Button,
              {
                onClick: () => extendTable("row", rowNumber),
                className: componentClassName("rowControls-add"),
                square: true,
                borderRadius: "full",
                size: "small",
                distinction: "seamless",
                style: rowStyle,
                children: /* @__PURE__ */ jsx(Icon, { blueprintIcon: "plus" })
              }
            ),
            /* @__PURE__ */ jsx("div", { className: componentClassName("rowControls-line"), style: rowStyle })
          ] }, rowNumber);
        }) }),
        /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            className: componentClassName("appendColumn"),
            onClick: () => extendTable("column"),
            contentEditable: false,
            children: /* @__PURE__ */ jsx(Icon, { blueprintIcon: "plus" })
          }
        ),
        /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            className: componentClassName("appendRow"),
            onClick: () => extendTable("row"),
            contentEditable: false,
            children: /* @__PURE__ */ jsx(Icon, { blueprintIcon: "plus" })
          }
        ),
        children
      ]
    }
  );
});
export {
  EditorTableElement
};
//# sourceMappingURL=EditorTableElement.js.map
